import { Injectable } from '@angular/core';

@Injectable()
export class FormatterService {
    public formatArticleNumber(articleNumber: string) {
        if (!articleNumber)
            return articleNumber;

        // 123456 => 123 456
        const matches: RegExpMatchArray = articleNumber.match(/^(\d{3})*(\d+)/);
        if (matches.length === 0)
            return articleNumber;

        return matches.slice(1).join(' ');
    }
}



// WEBPACK FOOTER //
// ./src/app/core/formatter.service.ts